import { connect } from 'react-redux';

import ActiveStatusActions from './component';

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(ActiveStatusActions);
